import React, { useMemo } from 'react';

type AccreditationVersionsProviderProps = {
  children: React.ReactNode;
};

export type AccreditationVersionsProviderResponse = {};

export const AccreditationVersionsContext = React.createContext<AccreditationVersionsProviderResponse>(
  {} as AccreditationVersionsProviderResponse
);

const AccreditationVersionsProvider: ({ children }: AccreditationVersionsProviderProps) => any = ({ children }) => {
  const contextValue: AccreditationVersionsProviderResponse = useMemo(() => ({}), []);

  return <AccreditationVersionsContext.Provider value={contextValue}>{children}</AccreditationVersionsContext.Provider>;
};

export default AccreditationVersionsProvider;
